// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-mobile-app-get-app-app-nknui{display:block;text-decoration:none;width:150px}.components-mobile-app-get-app-app-nknui:hover{opacity:.85}.components-mobile-app-get-app-image-cbifm{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "components-mobile-app-get-app-app-nknui",
	"image": "components-mobile-app-get-app-image-cbifm"
};
module.exports = ___CSS_LOADER_EXPORT___;
